<template>
  <section class="estacao-trabalho">
    <div class="content">
      <Titulo
        title="Estação de Trabalho"
        description="Selecione as cadeiras conforme o layout numérico."
      />

      <FormulateForm name="estacao" class="row mt-4">
        <FormulateInput
          class="data col-md-4"
          type="date"
          name="dataEstacao"
          placeholder="Data de início"
          :help="dataFimStr"
          :validation="`required|after:${dataValidation}`"
          v-model="dataInicio"
          :min="dataMin"
          @input="calcularDataFim"
        />
        <FormulateInput
          class="meses col-md-4"
          type="number"
          name="meses"
          placeholder="Quantidade de meses"
          validation="required|number|between:0,13"
          v-model="meses"
          min="1"
          max="12"
          @input="calcularDataFim()"
        />
        <div class="col-md-4 col-lg-3 mt-2 mt-md-0">
          <Botao
            type="button"
            title="VER DISPONIBILIDADE"
            class="btn btn-cta font-weight-bold px-4 w-100"
            @click="filtrarEspacos"
            >VER DISPONIBILIDADE</Botao
          >
        </div>
      </FormulateForm>

      <div class="mt-4">
        <div class="row justify-content-center" v-if="loading">
          <loading />
        </div>
        <div class="row" :class="carregarPosicoes ? '' : 'd-none'">
          <div class="col-md-5">
            <div class="d-flex flex-wrap justify-content-center pt-3 pt-md-5">
              <div>
                <button
                  v-for="n in [6, 5, 4, 3, 2, 1]"
                  :key="n"
                  type="button"
                  class="dia d-flex flex-column text-center justify-content-center align-items-center border rounded my-2 mx-2"
                  @click="
                    estacoesReservadas.filter((pos) => pos === n).length
                      ? false
                      : selecionarPosicao(n)
                  "
                  :class="validaPosicao(n)"
                >
                  <span class="value">{{ n }}</span>
                </button>
              </div>
              <div>
                <button
                  v-for="n in [12, 11, 10, 9, 8, 7]"
                  :key="n"
                  type="button"
                  class="dia d-flex flex-column text-center justify-content-center align-items-center border rounded my-2 mx-2"
                  @click="
                    estacoesReservadas.filter((pos) => pos === n).length
                      ? false
                      : selecionarPosicao(n)
                  "
                  :class="validaPosicao(n)"
                >
                  <span class="value">{{ n }}</span>
                </button>
              </div>
              <div class="ml-4 ml-sm-1 ml-lg-4">
                <button
                  v-for="n in [18, 17, 16, 15, 14, 13]"
                  :key="n"
                  type="button"
                  class="dia d-flex flex-column text-center justify-content-center align-items-center border rounded my-2 mx-2"
                  @click="
                    estacoesReservadas.filter((pos) => pos === n).length
                      ? false
                      : selecionarPosicao(n)
                  "
                  :class="validaPosicao(n)"
                >
                  <span class="value">{{ n }}</span>
                </button>
              </div>
              <div>
                <button
                  v-for="n in [24, 23, 22, 21, 20, 19]"
                  :key="n"
                  type="button"
                  class="dia d-flex flex-column text-center justify-content-center align-items-center border rounded my-2 mx-2"
                  @click="
                    estacoesReservadas.filter((pos) => pos === n).length
                      ? false
                      : selecionarPosicao(n)
                  "
                  :class="validaPosicao(n)"
                >
                  <span class="value">{{ n }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-4 mt-md-0">
            <img
              src="@/assets/img/planta-desktop@2x.png"
              class="img-fluid d-none d-md-block"
              alt="Cadeiras"
            />
            <img
              src="@/assets/img/planta-mobile@2x.png"
              class="img-fluid d-block d-md-none"
              alt="Cadeiras"
            />
          </div>
        </div>
      </div>

      <div class="preco-total mt-5" v-if="valorTotal">
        <div class="preco-total-value text-primary">
          {{ valorTotal | currency }}
        </div>
        <div class="preco-total-label">valor total</div>
      </div>
      <div v-else class="mt-5 pt-5"></div>

      <div class="row mt-4 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/produto/cdl-varejo-inteligente/produtos"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Próximo"
            @click="disabled ? '' : salvarReserva()"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
            :disabled="disabled"
            :class="{ disabled: disabled }"
            >PRÓXIMO</Botao
          >
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </section>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
export default {
  name: "CdlSaude",
  components: { Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente/produtos",
        },
        {
          nome: "Estação de Trabalho",
          id: "estacao-trabalho",
          produto: "CDL Varejo Inteligente",
        },
      ],
      filtroAno: 2021,
      filtroMes: 2,
      cadeiras: [],
      posicaoSel: [],
      selecionado: [],
      dataMin: null,
      dataValidation: null,
      dataInicio: null,
      meses: null,
      dataFim: null,
      dataFimStr: null,
      valorTotal: null,
      valor: 0,
      disabled: true,
      estacoesReservadas: [],
      carregarPosicoes: false,
      loading: false,
    };
  },
  methods: {
    montarDados() {
      const date = new Date();
      date.setDate(date.getDate() + 1);
      this.dataMin =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      this.dataValidation =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + (date.getDate() - 1)).slice(-2);

      if (sessionStorage.getItem("reserva")) {
        this.dadosReserva = JSON.parse(sessionStorage.getItem("reserva"));
        this.posicaoSel = this.dadosReserva.dadosReserva.estacoes;
        this.dataInicio = this.dadosReserva.dadosReserva.dataInicio;
        this.meses = this.dadosReserva.dadosReserva.qtdMeses;
        this.calcularDataFim();
        this.filtrarEspacos();
      }

      var valores = JSON.parse(sessionStorage.getItem("valoresProdutos"));
      var result = valores.filter(
        (el) => el.agendaId === this.urlParams.idAgenda
      );

      this.valor = result[0].valor;
    },
    filtrarEspacos() {
      this.$formulate.handle({ inputErrors: { dataEstacao: null } }, "estacao");
      this.$formulate.handle({ inputErrors: { meses: null } }, "estacao");
      if (this.dataInicio && this.dataFim) {
        this.loading = true;
        this.$http
          .get(
            "/api/Agenda/ConsultarAgenda?agendaId=" +
              this.urlParams.idAgenda +
              "&inicio=" +
              this.dataInicio +
              "&fim=" +
              this.dataFim.getFullYear() +
              "-" +
              ("0" + (this.dataFim.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + this.dataFim.getDate()).slice(-2)
          )
          .then((response) => {
            this.estacoesReservadas = [];
            this.carregarPosicoes = true;
            this.loading = false;
            const agendas = response.data;
            agendas.forEach((agenda) => {
              agenda.estacoes.forEach((estacao) => {
                this.estacoesReservadas.push(estacao);
              });
            });
          })
          .catch((error) => {
            if (error.response.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
          });
      } else {
        if (!this.meses) {
          this.$formulate.handle(
            {
              inputErrors: { meses: "Informe a quantidade de meses." },
              hasErrors: { meses: true },
            },
            "estacao"
          );
        }
        if (!this.dataInicio) {
          this.$formulate.handle(
            {
              inputErrors: { dataEstacao: "Informe o dia da reserva." },
              hasErrors: { dataEstacao: true },
            },
            "estacao"
          );
        }
      }
    },
    selecionarPosicao(n) {
      if (this.posicaoSel.filter((sel) => sel === n).length) {
        this.posicaoSel = this.posicaoSel.filter((sel) => sel !== n);
      } else {
        this.posicaoSel.push(n);
      }
      this.calcularValorTotal();
    },
    calcularValorTotal() {
      if (
        this.dataInicio &&
        this.valor &&
        this.meses &&
        this.posicaoSel.length
      ) {
        this.valorTotal = this.valor * this.meses * this.posicaoSel.length;
        this.disabled = false;
      } else {
        this.valorTotal = 0;
        this.disabled = true;
      }
    },
    validaPosicao(n) {
      const sel = this.posicaoSel.filter((sel) => sel === n);
      if (sel.length) {
        return "bg-warning";
      } else {
        if (this.estacoesReservadas.filter((pos) => pos === n).length) {
          return "bg-danger";
        } else {
          return "bg-white";
        }
      }
    },
    calcularDataFim() {
      if (this.dataInicio && this.meses) {
        const dataInicio = new Date(this.dataInicio);
        const dataFim = new Date(this.dataInicio);
        dataFim.setMonth(dataInicio.getMonth() + parseInt(this.meses));
        this.dataFimStr =
          "Encerra no dia: " +
          ("0" + dataFim.getDate()).slice(-2) +
          "/" +
          ("0" + (dataFim.getMonth() + 1)).slice(-2) +
          "/" +
          dataFim.getFullYear();
        this.dataFim = dataFim;
      }
      this.carregarPosicoes = false;
      this.calcularValorTotal();
    },
    salvarReserva() {
      sessionStorage.setItem("reserva", JSON.stringify(dadosReserva));
      const dadosReserva = {
        tipoReserva: "estacao-trabalho",
        idAgenda: this.urlParams.idAgenda,
        dadosReserva: {
          estacoes: this.posicaoSel,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          qtdMeses: this.meses,
        },
      };
      sessionStorage.setItem("reserva", JSON.stringify(dadosReserva));
      this.$router.push({ name: "formularioEstacaoTrabalho" });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montarDados();
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.estacao-trabalho /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  .data {
    margin-top: 1px !important;
    height: 40px;
    input {
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
  .meses {
    margin-top: 1px !important;
    input {
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
  .formulate-input-help {
    margin-top: 5px;
    font-size: 15px;
    color: #a6a9b2;
  }
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }
    .formulate-input-element {
      padding: 5px;
      background: white;
      input,
      select {
        background: white;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
      }
    }
  }
  .label {
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 5px;
    line-height: 1.4;
  }
  .value {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    color: #000;
    line-height: 1.4;
    &.value-small {
      font-size: 14px;
    }
  }
  .dia {
    width: 57px;
    height: 57px;
  }
  .preco-total-label {
    font-weight: 300;
    font-size: 1rem;
    margin-bottom: 10px;
  }
  .preco-total-value {
    font-weight: bold;
    font-size: 1.4rem;
    text-transform: uppercase;
    color: #000;
    line-height: 1.4;
  }
}
</style>
